<div class="alert-status-wrapper">
  <div class="status" [class]="ResolvedStatus[resolvedStatus!]">
    {{ ResolvedStatus[resolvedStatus!] | splitByCapitalLetterPipe }}
  </div>
</div>
